import { ShowButton, TextField, useTable } from "@refinedev/antd";
import { useNavigation } from "@refinedev/core";
import { Space, Table } from "antd";
import dayjs from "dayjs";

import { AppImagePreview } from "../../../components";
import { DayMonthYear, errorNotification } from "../../../helpers";
import { PlayerAwardItem } from "../Lib";
import { AwardsDelete } from "../Awards-Delete/Awards-Delete";
import s from "../../News/News-List/All-News/All-News.module.scss";

const getAwardTypeLabel = (record: PlayerAwardItem) =>
  record.typeDisplayName ||
  record.typeName ||
  record.awardTypeDisplayName ||
  record.awardType?.displayName ||
  record.awardTypeName ||
  record.awardType?.name ||
  "—";

const getAwardImage = (record: PlayerAwardItem) =>
  record.typeImageUrl ||
  record.awardImage ||
  record.imageUrl ||
  record.awardType?.imageUrl ||
  "";

export const AwardsList = () => {
  const { push } = useNavigation();

  const { tableProps } = useTable<PlayerAwardItem>({
    dataProviderName: "awardsDataProvider",
    resource: "awards",
    syncWithLocation: false,
    queryOptions: {
      enabled: true,
    },
    ...errorNotification(),
  });

  const handleNavigateToAward = (id: string | number) => {
    push(`/awards/${id}`);
  };

  return (
    <Table
      {...tableProps}
      scroll={{ x: 1200 }}
      rowKey="id"
      locale={{
        emptyText: <div style={{ margin: 56 }}>Награды отсутствуют</div>,
      }}
      showSorterTooltip={false}
      pagination={false}
    >
      <Table.Column<PlayerAwardItem>
        width={260}
        key="imageUrl"
        title={"Изображение"}
        render={(_, record) => (
          <AppImagePreview
            imageURL={getAwardImage(record)}
            useS3={
              Boolean(getAwardImage(record)) &&
              !String(getAwardImage(record)).startsWith("http")
            }
            sharedStyles={s.imageUrl}
          />
        )}
      />
      <Table.Column<PlayerAwardItem>
        width={240}
        key="awardType"
        title="Номинация"
        render={(_, record) => <TextField value={getAwardTypeLabel(record)} />}
      />
      <Table.Column<PlayerAwardItem>
        width={360}
        dataIndex={"text"}
        key="text"
        title="Описание"
        render={(_, record) => <TextField value={record.text} />}
      />
      <Table.Column<PlayerAwardItem>
        width={180}
        dataIndex={"dateFrom"}
        key="dateFrom"
        title="Дата"
        render={(value) => (
          <TextField value={value ? dayjs(value).format(DayMonthYear) : "—"} />
        )}
      />

      <Table.Column<PlayerAwardItem>
        width={260}
        fixed={"right"}
        key="actions"
        title="Действия"
        render={(_, record) => (
          <Space size={8} direction="vertical" style={{ width: "100%" }}>
            <ShowButton
              onClick={() => handleNavigateToAward(record.id)}
              size={"small"}
              block
            >
              Смотреть / Редактировать
            </ShowButton>
            <AwardsDelete id={Number(record.id)} name={record.text} />
          </Space>
        )}
      />
    </Table>
  );
};
